class ParallaxSection {
    constructor(sectionSelector) {
        this.section = document.querySelector(sectionSelector);
        this.paralaxElements = document.querySelectorAll('.paralax-element');
        
        this.init();
    }

    init() {
        window.addEventListener('scroll', this.handleScroll.bind(this));
    }
  
    handleScroll() {
        if (this.isElementInViewport(this.section)) {
            const scrollDistance = this.calculateScrollDistance(this.section);
            this.updateTransforms(scrollDistance);
        }
    }
  
    isElementInViewport(element) {
        const rect = element.getBoundingClientRect();
        return rect.top < window.innerHeight && rect.bottom > 0;
    }

    calculateScrollDistance(element) {
        return -element.getBoundingClientRect().top;
    }

    updateTransforms(distance) {
        this.paralaxElements.forEach(element => element.style.transform = `translateY(${distance * element.dataset.speed}px)`);
    }    
}

const paralaxSection = new ParallaxSection('.paralax-section');